<template>
  <div class="LIST">
    <service-card
        v-for="service in services"
        :key="service.id"
        :service="service"/>
  </div>
</template>
<script>

import ServiceCard from './ServiceCard';

export default {
  name: 'services-pricing',
  components: {
    ServiceCard,
  },
  props: {
    services: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .LIST {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: start;
    @include mobile-only {
      justify-content: space-between;
    }
  }
</style>
